import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SaleJetBlockData from '../../../Models/Content/SaleJetBlockData';
import SaleHeader from '../../Shared/SaleHeader/SaleHeader';
import Sale from './saleJet';

export default class SaleJetBlock extends EpiComponent<SaleJetBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['sale-jet-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <div className="sale-page-wrapper">
            <SaleHeader />
            <Sale iContent={this.props.data} context={this.getContext()} />
        </div>
      </div>
    )
  }
}
